// extracted by mini-css-extract-plugin
export default {"text":"Text_text__+pRco"};